import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { commonTokens } from "./commonTokens.js";
import { pinkBrandPlusColorsTokens } from "./commonPlusColors.js";

// https://maketintsandshades.com/#f2007d
// https://maketintsandshades.com/#4972D1
export var pinkPantherTokens = _objectSpread(_objectSpread(_objectSpread({
  'brand-name': 'lastminute',
  'theme-name': 'pink-panther',
  'colors-null': 'transparent',
  'colors-primary': 'var(--lmn-ds-colors-primary-400)',
  'colors-primary-50': '#fee6f2',
  'colors-primary-100': '#fbb3d8',
  'colors-primary-200': '#f980be',
  'colors-primary-300': '#f64da4',
  'colors-primary-400': '#f2007d',
  'colors-primary-500': '#da0071',
  'colors-primary-600': '#c20064',
  'colors-primary-700': '#a90058',
  'colors-primary-800': '#91004b',
  'colors-secondary': 'var(--lmn-ds-colors-secondary-400)',
  'colors-secondary-50': '#fee6f2',
  'colors-secondary-100': '#fbb3d8',
  'colors-secondary-200': '#f980be',
  'colors-secondary-300': '#f64da4',
  'colors-secondary-400': '#f2007d',
  'colors-secondary-500': '#da0071',
  'colors-secondary-600': '#c20064',
  'colors-secondary-700': '#a90058',
  'colors-secondary-800': '#91004b',
  'colors-tertiary': 'var(--lmn-ds-colors-tertiary-400)',
  'colors-tertiary-50': '#d4f2f1',
  'colors-tertiary-100': '#aae5e3',
  'colors-tertiary-200': '#7fd8d5',
  'colors-tertiary-300': '#55cbc7',
  'colors-tertiary-400': '#2abeb9',
  'colors-tertiary-500': '#229894',
  'colors-tertiary-600': '#19726f',
  'colors-tertiary-700': '#114c4a',
  'colors-tertiary-800': '#083d3b',
  'colors-accent': 'var(--lmn-ds-colors-primary-400)',
  'colors-accent-50': 'var(--lmn-ds-colors-primary-50)',
  'colors-accent-100': 'var(--lmn-ds-colors-primary-100)',
  'colors-accent-200': 'var(--lmn-ds-colors-primary-200)',
  'colors-accent-300': 'var(--lmn-ds-colors-primary-300)',
  'colors-accent-400': 'var(--lmn-ds-colors-primary-400)',
  'colors-accent-500': 'var(--lmn-ds-colors-primary-500)',
  'colors-accent-600': 'var(--lmn-ds-colors-primary-600)',
  'colors-accent-700': 'var(--lmn-ds-colors-primary-700)',
  'colors-accent-800': 'var(--lmn-ds-colors-primary-800)'
}, pinkBrandPlusColorsTokens), commonTokens), {}, {
  'font-family': "'Open Sans', Arial, Helvetica, sans-serif",
  'font-url': '//fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&display=swap'
});